import {
    createBrowserRouter,
    RouterProvider
} from "react-router-dom";
import styles from "./App.module.css"
import {routes} from "./routes"
import {isLoggedIn} from "./services/authService";
import {Suspense, useEffect, useState} from "react";
import LoadingBars from "./components/loadingBars";
import {store} from "./store";
import AddListModal from "./components/modals/addListModal";
import NewAnimeModal from "./components/modals/newAnimeModal";
import {closeNewAnimeModal} from "./slices/newAnimeModalSlice";
import SideNav from "./components/sideNav";
require('bootstrap')

function App() {
    const router = createBrowserRouter(routes);
    const isAuthenticated = isLoggedIn();

    let mainClass = isAuthenticated ? "col-12 col-lg-10" : "col-12 col-lg-3 offset-lg-4";
    const navCol = isAuthenticated ? (
        <>
            <div
                className={`col-12 col-lg-2 ${styles.navCol}`}
            >
                <SideNav />
            </div>
        </>
    ) : "";

    const [isListModalOpen, setIsListModalOpen] = useState(false);
    const [isNewAnimeModalOpen, setIsNewAnimeModalOpen] = useState(false);
    const [isNavShown, setIsNavShown] = useState(false);
    const [mainClassState, setMainClassState] = useState(mainClass);

    const url = window.location.pathname;

    useEffect(() => {
        if (url.includes("shared") || url.includes("invite")) {
            setMainClassState("col-10 col-lg-10")
            setIsNavShown(false);
        } else {
            setIsNavShown(true);
        }

        if (url.includes("login")) {
            setMainClassState(mainClass);
        }
    }, [url, mainClass]);

    store.subscribe(() => {
        setIsListModalOpen(store.getState().isListModalOpen.value);
        setIsNewAnimeModalOpen(store.getState().isNewAnimeModalOpen.value);
    });

    return (
       <>
           <Suspense fallback={<LoadingBars />}>
               <div className="container-fluid">
                   <AddListModal isOpen={isListModalOpen} />
                   <NewAnimeModal isOpen={isNewAnimeModalOpen} onClose={
                       () => {
                           store.dispatch(closeNewAnimeModal())
                       }
                   } />
                   <div className="row text-light" style={{backgroundColor: "#454b51"}} id="body-row">
                       {isNavShown && navCol}
                       <div id="main" style={{minHeight: "100vh"}} className={`${mainClassState}`}>
                           <RouterProvider router={router} />
                       </div>
                   </div>
               </div>
           </Suspense>
       </>

    );
}

export default App;